import { createLazyComponent } from 'helpers/createLazyComponent'

const EventSettingsLazy = createLazyComponent(() => import('./EventSettings'))

export default EventSettingsLazy
